import { Controller } from "@hotwired/stimulus"

export default class EmojiMartDropdownController extends Controller {
  static targets = ["toggle", "menu", "picker"]

  connect() {
    this.isOpening = false
    this.watchFrame = null

    this.handleOutsidePointerDown = this.handleOutsidePointerDown.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.watchDistance = this.watchDistance.bind(this)
    this.hide = this.hide.bind(this)
    document.addEventListener("pointerdown", this.handleOutsidePointerDown, true)
    document.addEventListener("keydown", this.handleEscape)
    this.element.addEventListener("emoji-mart-dropdown:hide", this.hide)
  }

  disconnect() {
    document.removeEventListener("pointerdown", this.handleOutsidePointerDown, true)
    document.removeEventListener("keydown", this.handleEscape)

    this.stopWatchingDistance()
  }

  openPicker(event){
    const menu = this.menuTarget
    menu.classList.remove("d-none")
    menu.style.visibility = "visible"
    menu.style.position = "absolute"
    menu.style.right = "0px"
    menu.style.top = "30px"
    menu.style.zIndex = "9999"
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen()) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.isOpening = true
    this.menuTarget.classList.remove("d-none")
    this.menuTarget.style.visibility = "hidden"

    requestAnimationFrame(() => {
      this.positionMenu()

      requestAnimationFrame(() => {
        this.positionMenu()
        this.menuTarget.style.visibility = "visible"
        this.startWatchingDistance()
        this.isOpening = false
      })
    })
  }

  hide(event = null) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (!this.isOpen()) return

    this.menuTarget.classList.add("d-none")
    this.clearInlinePosition()
    this.stopWatchingDistance()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  isOpen() {
    return !this.menuTarget.classList.contains("d-none")
  }

  handleOutsidePointerDown(event) {
    if (!this.isOpen()) return
    if (this.isOpening) return

    const path = event.composedPath ? event.composedPath() : []
    const clickedInsideMenu = path.includes(this.menuTarget)
    const clickedToggle = path.includes(this.toggleTarget)

    if (clickedInsideMenu || clickedToggle) return

    this.hide()
  }

  handleEscape(event) {
    if (event.key === "Escape") this.hide()
  }

  handleResize() {
    if (this.isOpen()) {
      this.positionMenu()
      // requestAnimationFrame(() => this.positionMenu())
    }
  }

  positionMenu() {
    const toggleRect = this.toggleTarget.getBoundingClientRect()
    const menu = this.menuTarget
    const gap = 8
    const viewportPadding = 8

    menu.style.position = "fixed"
    menu.style.left = "0px"
    menu.style.top = "0px"
    menu.style.zIndex = "9999"

    const menuRect = menu.getBoundingClientRect()

    let left = toggleRect.left
    let top = toggleRect.top - menuRect.height - gap

    if (top < viewportPadding) {
      top = toggleRect.bottom + gap
    }

    if (left + menuRect.width > window.innerWidth - viewportPadding) {
      left = window.innerWidth - menuRect.width - viewportPadding
    }

    if (left < viewportPadding) left = viewportPadding

    if (top + menuRect.height > window.innerHeight - viewportPadding) {
      top = Math.max(viewportPadding, window.innerHeight - menuRect.height - viewportPadding)
    }

    menu.style.left = `${Math.round(left)}px`
    menu.style.top = `${Math.round(top)}px`
  }

  startWatchingDistance() {
    this.stopWatchingDistance()
    this.watchFrame = requestAnimationFrame(this.watchDistance)
  }

  stopWatchingDistance() {
    if (this.watchFrame) {
      cancelAnimationFrame(this.watchFrame)
      this.watchFrame = null
    }
  }

  watchDistance() {
    if (!this.isOpen()) return
    this.positionMenu()

    const toggleRect = this.toggleTarget.getBoundingClientRect()
    const menuRect = this.menuTarget.getBoundingClientRect()

    const toggleOffScreen =
      toggleRect.bottom < 0 ||
      toggleRect.top > window.innerHeight ||
      toggleRect.right < 0 ||
      toggleRect.left > window.innerWidth

    const horizontalBuffer = 180
    const verticalBuffer = 500

    const horizontallyDetached =
        menuRect.right < toggleRect.left - horizontalBuffer ||
        menuRect.left > toggleRect.right + horizontalBuffer

    const verticallyDetached =
        menuRect.bottom < toggleRect.top - verticalBuffer ||
        menuRect.top > toggleRect.bottom + verticalBuffer

    if (toggleOffScreen || horizontallyDetached || verticallyDetached) {
      // this.hide()
      return
    }

    this.watchFrame = requestAnimationFrame(this.watchDistance)
  }

  clearInlinePosition() {
    const menu = this.menuTarget
    menu.style.visibility = ""
    menu.style.left = ""
    menu.style.top = ""
    menu.style.position = ""
    menu.style.zIndex = ""
  }
}